<template>
    <div class="ai-content-list" :class="marginClass">
        <slot></slot>
    </div>
</template>
<script>
export default {
    props: {
        hasMargin: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        marginClass() {
            return this.hasMargin ? 'ai-content-list--margin' : '';
        },
    },
};
</script>
<style lang="scss" scoped>
.ai-content-list {
    border-left: 6px solid var(--colors-common-border-lighter);
    padding: 0 0 0 10px;

    &--margin {
        margin: 0 0 var(--spacing-3);
    }
}
</style>
